import React, { memo } from 'react';

import SvgNew from '../../SvgNew';

const SortIcon = ({
                      highlighted,
                      isAsc
                  }) => {
    if (!highlighted) return (
        <SvgNew name="sort" />
    );

    return (
        <SvgNew name={isAsc ? 'sortAsc' : 'sortDsc'} />
    );
};

export default memo(SortIcon);


// WEBPACK FOOTER //
// ./App/components/Table/components/SortIcon.jsx